import { createFileRoute, Outlet } from "@tanstack/react-router";
import { applyAuthGuard } from "@/routes/-auth-guard";

export const Route = createFileRoute("/admin")({
  beforeLoad: ({ location }) =>
    applyAuthGuard(location.pathname, new URLSearchParams(location.searchStr)),
  component: () => <Outlet />,
});
